export default __webpack_public_path__ + "static/media/3.9f61cbbb.jpg";